<template>
  <div :data-bottom-banner-loading="loading">
    <a
      ref="wrapper"
      v-if="identifier && !hasBeenClosed"
      :class="bottomBannerClasses"
      :href="linkUrl"
      @click.prevent="redirectToLinkUrl"
    >
      <PromoBanner
        variant="fixed-bottom"
        :images="images"
        :headline="headline"
        :text="text"
        :linkText="linkText"
        :closeHandler="closeBanner"
      />
    </a>
  </div>
</template>

<script>
import cookieOnCloseMixin from '@/mixins/cookie-on-close'
import promoBannerWrapperMixin from '@/mixins/promo-banner-wrapper'

export default {
  name: 'BottomBanner',
  mixins: [cookieOnCloseMixin, promoBannerWrapperMixin],

  data() {
    return {
      displayDelay: 500,
    }
  },

  computed: {
    bottomBannerClasses() {
      const defaults = ['bottom-bar', 'bottom-banner']
      const optionals = {
        'bottom-banner--link': this.linkUrl,
        'is-slid-up': this.shouldBeVisible,
      }
      return [...defaults, optionals]
    },

    isMobile() {
      return window.innerWidth < On.MediaQueries.width.medium
    },

    shouldInitBottomBanner() {
      return !document.body.matches('.modal_visible') && On.CookieConsent.isHidden()
    },
  },

  created() {
    window.On.BottomBanner.init = identifier => {
      if (this.shouldInitBottomBanner && !this.hasBeenClosedInCookie(identifier)) {
        this.init(identifier)
      }
    }

    if (this.shouldInitBottomBanner) this.init()
  },

  methods: {
    displayBanner() {
      this.scheduleDisplay()
    },

    scheduleDisplay() {
      if (this.hasBeenClosed) {
        this.loading = false
        return
      }
      setTimeout(() => {
        this.$nextTick(() => {
          imagesLoaded(this.$el, () => {
            this.shouldBeVisible = true
            this.loading = false
          })
        })
      }, this.displayDelay)
    },
  },
}
</script>

<style scoped lang="scss">
.bottom-banner {
  display: block;
  padding: 0;

  &--link {
    cursor: pointer;

    &:hover {
      background-color: $color-storm-blue-light;
    }
  }
}
</style>
